import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <nav data-testid="navbar" className="bg-[var(--ls-bg-light)] sticky top-0 z-50" role="navigation" aria-label="Main navigation">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-[100] focus:bg-[var(--ls-navy)] focus:text-white focus:px-4 focus:py-2 focus:rounded">Skip to content</a>
      <div className="ls-container flex items-center justify-between h-16">
        <Link to="/" data-testid="navbar-logo" className="flex items-center gap-2">
          <img src="/logo.png" alt="LegaSecure" className="h-9 w-auto" />
          <span className="text-xs text-[var(--ls-text-light)] font-['Outfit'] hidden sm:inline">Guide</span>
        </Link>

        <div className="hidden md:flex items-center gap-6 text-sm font-medium">
          <Link to="/all-cities" data-testid="nav-cities" className="text-[var(--ls-text)] hover:text-[var(--ls-gold)] transition-colors">Cities</Link>
          <Link to="/all-countries" data-testid="nav-countries" className="text-[var(--ls-text)] hover:text-[var(--ls-gold)] transition-colors">OFW Countries</Link>
          <Link to="/blog" data-testid="nav-blog" className="text-[var(--ls-text)] hover:text-[var(--ls-gold)] transition-colors">Blog</Link>
          <a href="https://legasecure.com" data-testid="nav-pricing" className="text-[var(--ls-text)] hover:text-[var(--ls-gold)] transition-colors">Pricing</a>
          <a href="https://legasecure.com/contact" data-testid="nav-contact" className="text-[var(--ls-text)] hover:text-[var(--ls-gold)] transition-colors">Contact</a>
          <a href="https://legasecure.com" data-testid="nav-main-cta" className="ls-btn-gold text-sm py-2 px-5">Visit LegaSecure</a>
        </div>

        <button data-testid="mobile-menu-toggle" className="md:hidden text-[var(--ls-navy)] text-xl" onClick={() => setMobileOpen(!mobileOpen)} aria-label="Toggle menu" aria-expanded={mobileOpen}>
          <i className={`fa-solid ${mobileOpen ? 'fa-xmark' : 'fa-bars'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div data-testid="mobile-menu" className="md:hidden bg-[var(--ls-bg-light)] border-t border-[var(--ls-border)] px-6 py-4 space-y-3">
          <Link to="/all-cities" className="block py-2 text-[var(--ls-text)]" onClick={() => setMobileOpen(false)}>Cities</Link>
          <Link to="/all-countries" className="block py-2 text-[var(--ls-text)]" onClick={() => setMobileOpen(false)}>OFW Countries</Link>
          <Link to="/blog" className="block py-2 text-[var(--ls-text)]" onClick={() => setMobileOpen(false)}>Blog</Link>
          <a href="https://legasecure.com" className="block py-2 text-[var(--ls-text)]">Pricing</a>
          <a href="https://legasecure.com/contact" className="block py-2 text-[var(--ls-text)]">Contact</a>
          <a href="https://legasecure.com" className="ls-btn-gold block text-center text-sm py-2 mt-2">Visit LegaSecure</a>
        </div>
      )}
    </nav>
  );
}
